<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link
                v-bind:to="'/aliado/contrato/' + id_aliado"
                class="btn btn-orange rounded-pill"
              >
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
              <div class="float-end">
                <router-link v-bind:to="'/aliado/solicitudes/' + id_aliado" class="btn btn-success rounded-pill ms-1">
                  Solicitud de Piezas<i class="bx bx-chevron-right"></i>
                </router-link>
              </div>
              <br />
            </div>
            <div class="mt-2 mb-3">
              <h3 class="text-orange fw-bold">{{ aliado.nombre_aliado }}</h3>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="text-orange fw-bold">Anexos</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div v-for="(anexo, index_anexo) in anexos" v-bind:key="index_anexo" class="col-lg-3">
                    <div class="card card-body border shadow">
                      <div class="text-center">
                        <div v-if="anexo.anexo != null" class="mb-4">
                          <a v-bind:href="anexo.anexo" target="_blank">
                            <i class="bx bx-file-blank bx-lg"></i>
                          </a>
                          <br />
                          <small> Subido: {{ anexo.fecha_registro }} </small><br />
                          <router-link v-if="
                            aliado.estado_aliado != 2 ||
                            session.usuario.perfil == 0
                          " v-bind:to="
  '/cargar_anexo/' +
  id_aliado +
  '/' +
  anexo.id_tipo_anexo
" class="btn btn-outline-dark rounded-pill btn-sm mt-3 mb-2">
                            <i class="bx bx-upload"></i> Modificar archivo
                          </router-link>
                        </div>
                        <div v-else>
                          <div>
                            <i class="bx bx-info-circle bx-lg text-muted"></i>
                            <br />
                            No se ha cargado archivo.
                          </div>
                          <br />
                          <router-link v-bind:to="
                            '/cargar_anexo/' +
                            id_aliado +
                            '/' +
                            anexo.id_tipo_anexo
                          " class="btn btn-outline-dark rounded-pill btn-sm mb-4">
                            <i class="bx bx-upload"></i> Cargar archivo
                          </router-link>
                        </div>
                        <div>
                          <span class="fw-bold text-orange">{{
                            anexo.tipo_anexo
                          }}</span>
                          <span v-if="anexo.id_tipo_anexo == 10" class="text-muted">
                            (Opcional)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <router-link v-bind:to="'/aliado/info_secundaria/' + id_aliado"
                class="btn btn-outline-secondary rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>
              <div class="float-end">
                <router-link v-bind:to="'/aliado/solicitudes/' + id_aliado" class="btn btn-orange rounded-pill">
                  <i class="bx bx-chevron-left"></i> Finalizar
                </router-link>
                <router-link v-bind:to="'/aliado/solicitudes/' + id_aliado" class="btn btn-success rounded-pill ms-1">
                  Solicitudes <i class="bx bx-chevron-right"></i>
                </router-link>
              </div>
              <br />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Anexos",
  metaInfo: {
    title: "Anexos - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      loading_solicitudes: true,
      id_aliado: null,
      aliado: [],
      anexos: [],
      solicitudes: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
    this.get_anexos();
    this.get_solicitud();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_anexos: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/anexos/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.anexos = response.data.data.anexos;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_solicitud: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url + "aliados/solicitudes_piezas/" + this.id_aliado,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitudes = response.data.data.solicitudes;
          this.loading_solicitudes = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
};
</script>
<style scoped>
a.btn.btn-success.rounded-pill.ms-1 {
  font-size: 21px;
}
</style>